"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogoutUrl = exports.getLoginUrl = exports.getForumsSignOutUrl = exports.getForumsSignInUrl = exports.getAuthUrl = void 0;
var _environment = require("./environment");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var buildAuthQueryParams = function buildAuthQueryParams(urlType, _ref) {
  var email = _ref.email,
    redirectUrl = _ref.redirectUrl,
    prompt = _ref.prompt,
    _ref$experience = _ref.experience,
    experience = _ref$experience === void 0 ? 'entry-auth' : _ref$experience;
  var queryParams = [];
  if (email) {
    queryParams.push("login_hint=".concat(email));
  }
  if (experience) {
    queryParams.push("application=community--".concat(experience));
  }
  if (redirectUrl) {
    queryParams.push(urlType === 'identity' ? "continue=".concat(redirectUrl) : "referer=".concat(redirectUrl));
  }
  if (prompt) {
    queryParams.push("prompt=".concat(prompt));
  }
  return queryParams;
};
var getAuthUrl = exports.getAuthUrl = function getAuthUrl(type, queryParamValues, env) {
  var environment = (0, _environment.getEnvironment)(env);
  var config = _environment.ENVIRONMENT_CONFIGS[environment];
  var queryParams = buildAuthQueryParams('identity', queryParamValues);
  return "".concat(config.IDENTITY_BASE_URL, "/").concat(type, "?").concat(queryParams.join('&'));
};
var getForumsSignInUrl = exports.getForumsSignInUrl = function getForumsSignInUrl(queryParamValues, env) {
  var environment = (0, _environment.getEnvironment)(env);
  var config = _environment.ENVIRONMENT_CONFIGS[environment];
  // Only include referer parameter for OAuth2 SSO redirect
  var queryParams = [];
  if (queryParamValues.redirectUrl) {
    queryParams.push("referer=".concat(queryParamValues.redirectUrl));
  }
  var queryString = queryParams.length > 0 ? "?".concat(queryParams.join('&')) : '';
  return encodeURIComponent("".concat(config.HOME_BASE_URL, "/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect").concat(queryString));
};
var getForumsSignOutUrl = exports.getForumsSignOutUrl = function getForumsSignOutUrl(redirectUrl, env) {
  var environment = (0, _environment.getEnvironment)(env);
  var config = _environment.ENVIRONMENT_CONFIGS[environment];
  return encodeURIComponent("".concat(config.HOME_BASE_URL, "/forums/s/plugins/custom/atlassian/").concat(config.KHOROS_ENDPOINT_PATH, "/khoros_logout?referer=").concat(redirectUrl));
};
var getLoginUrl = exports.getLoginUrl = function getLoginUrl(queryParamValues, env) {
  // Build the forums signin URL with the redirect URL
  var forumsSignInUrl = getForumsSignInUrl(queryParamValues);
  // redirect the identity login to the forums signin url
  var identityLoginUrl = getAuthUrl('login', _objectSpread(_objectSpread({}, queryParamValues), {}, {
    redirectUrl: "".concat(forumsSignInUrl)
  }), env);
  return identityLoginUrl;
};
var getLogoutUrl = exports.getLogoutUrl = function getLogoutUrl(queryParamValues, env) {
  // Build the forums signout URL with the redirect URL
  var forumsSignOutUrl = getForumsSignOutUrl(queryParamValues.redirectUrl, env);
  // redirect the identity logout to the forums signout url
  var identityLogoutUrl = getAuthUrl('logout', _objectSpread(_objectSpread({}, queryParamValues), {}, {
    redirectUrl: "".concat(forumsSignOutUrl)
  }), env);
  return identityLogoutUrl;
};